<template>
    <div class="container-fluid px-0">
        <div class="container-fluid bg-light">
            <header class="container">
                <div class="row justify-content-start">
                    <nav class="navbar pr-0">
                        <span class="navbar-brand">
                            <img src="/logo-icon.svg" width="45" height="45" class="d-inline-block align-middle"
                                 alt="Home">
                        </span>
                    </nav>
                    <section class="flex-fill pt-3 pb-0">
                        <div class="container">
                            <div class="progress w-100 rounded-0" style="height: 6px">
                                <div class="progress-bar" role="progressbar" style="width:100%"
                                     aria-valuenow="100"
                                     aria-valuemin="0"
                                     aria-valuemax="100">
                                </div>
                            </div>

                            <div class="row no-gutters">
                                <div class="flex-fill">
                                    <span class="">{{$t('Test completed!')}}</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </header>
        </div>

        <section class="jumbotron">
            <div class="container text-center">
                <template v-if="saved">
                    <h1 class="fw-medium text-uppercase">{{$t('Thank you!')}}</h1>
                    <p v-html="$t('sent_message', {email: form.email})"></p>
                    <p>
                        <a class="btn btn-primary rounded rounded-pill" v-bind:href="homeUrl">
                            {{$t('Home')}}
                        </a>
                    </p>
                </template>
                <div v-else class="row justify-content-center">
                    <div class="col-12 col-sm-10 col-md-8 col-lg-6 pb-4">
                        <h1 class="mb-4 fs-1 fw-medium">
                            {{$t('Where would you like to receive your results?')}}
                        </h1>
                        <form class="needs-validation recaptcha-aware-form" novalidate="" ref="form"
                              v-on:submit.prevent="collectLead">
                            <div class="mb-3">
                                <label for="contact-form-name" class="d-none">Name</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="ico vox-user"></i></span>
                                    </div>
                                    <input type="text" id="contact-form-name" name="name" v-model="form.name"
                                           class="form-control "
                                           :placeholder="$t('Full name')" required>
                                    <div class="invalid-feedback">
                                        The 'Full name' field is required.
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="contact-form-email" class="d-none">E-mail</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">@</span>
                                    </div>
                                    <input type="email" id="contact-form-email" name="email" v-model="form.email"
                                           class="form-control "
                                           :placeholder="$t('E-mail')" required>
                                    <div class="invalid-feedback">
                                        The 'E-mail' field is required.
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3 d-none">
                                <label for="contact-form-phone" class="d-none">Phone number</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="ico vox-phone"></i></span>
                                    </div>
                                    <input type="tel" id="contact-form-phone" name="phone" v-model="form.phone"
                                           class="form-control "
                                           placeholder="Phone number">
                                    <div class="invalid-feedback">
                                        The 'Phone number' field is required.
                                    </div>
                                </div>
                            </div>

                            <button class="btn btn-lg btn-block btn-primary" type="submit">
                                <span v-if="saving">
                                    Sending...
                                </span>
                                <span v-else>
                                    {{$t('Get results')}} <i class="ico vox-mdi-mail-send ml-3"></i>
                                </span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </section>

        <section class="text-center" v-if="!saved">
            <a v-if="!saved" class="btn btn-outline-dark rounded rounded-pill" :href="baseUrl">
                {{$t('Exit')}}
            </a>
        </section>
    </div>
</template>

<script>
    import Api from "../services/Api"
    import LocalStorage from "../services/LocalStorage"

    export default {
        data() {
            return {
                form: {
                    pipedrive_person_id: 0,
                    name: '',
                    email: '',
                    phone: 'dummy' // TODO: phone should allow NULL in the db
                },
                saved: false,
                saving: false
            }
        },

        mounted() {
            const answersList = LocalStorage.getAnswers();
            if (Object.keys(answersList).length === 0) {
                this.$router.push({'name': 'start'});
            }

            const person = LocalStorage.getPipedrivePerson()
            if (person) {
                if (person.id) {
                    this.form.pipedrive_person_id = person.id
                }
                if (person.name) {
                    this.form.name = person.name
                }
                if (person.email) {
                    this.form.email = person.email
                }
                if (person.phone) {
                    this.form.name = person.phone
                }

                if (person.id && person.name && person.name) {
                    this.collectLead()
                }
            }

            // TODO: if we go directly to /langtest/finish it shows the contact form even if the test isn't completed, we should drop the user to the next non-completed step
        },

        computed: {
            homeUrl() {
                const pathPieces = window.location.pathname.split('/');
                return '/' + (pathPieces[1] ? pathPieces[1] : pathPieces[0]);
            }
        },

        methods: {
            async collectLead() {
                let valid = this.$refs.form.checkValidity()

                if (valid) {
                    this.saving = true
                    window.scrollTo(0, 0)

                    const answersList = LocalStorage.getAnswers()
                    const contacts = this.form

                    try {
                        const response = await Api.collectLead(contacts, answersList)
                        this.saved = true
                        this.saving = false
                        LocalStorage.clear()

                        if (this.form.pipedrive_person_id === 0) {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                "event": "vox.lead"
                            });
                        }

                        setTimeout(function () {
                            if (response.data.url && response.data.url.length > 0) {
                                window.location = response.data.url
                            }
                        })
                    } catch (e) {
                        this.saved = false
                        this.saving = false
                    }
                }
            }
        }
    }
</script>
